import type { RadioProps } from '@/components/control/components/radio/radio.types';
import clsx from 'clsx';
import Control from '@/components/control';
import { choiceId } from '@/components/control/utils';
import '@/components/control/components/radio/radio.css';

export default function Radio(props: RadioProps) {
  const radioCn = clsx('control-radio', {
    'control-radio--horizontal': props.orientation === 'horizontal',
    'control-radio--vertical': props.orientation === 'vertical',
  });

  return (
    <div className={radioCn}>
      {props.choices.map((choice, index, choices) => {
        const id = choiceId(props.id, choice.value, index);
        return (
          <Control.RadioLabel
            key={id}
            id={id}
            value={props.value}
            state={props.state}
            choice={choice}
            choices={choices}
          >
            {({ focused, hovered, checked, state }) => (
              <div className='control-radio__label'>
                <Control.Choice
                  type='radio'
                  state={state}
                  checked={checked}
                  focused={focused}
                  hovered={hovered}
                  disabled={props.disabled}
                />
                <Control.HiddenInput
                  type='radio'
                  id={id}
                  value={choice.value}
                  name={props.id}
                  checked={checked}
                  disabled={props.disabled}
                  onChange={() => props.onChange(choice.value, props.id)}
                />
                <Control.RadioText size='lg' checked={checked}>
                  {choice.label}
                </Control.RadioText>
              </div>
            )}
          </Control.RadioLabel>
        );
      })}
    </div>
  );
}
